const ID_TRACKER = {};
const FIRST_ID = 0;

export function generateId(prefix = "id-") {
    ID_TRACKER[prefix] = (ID_TRACKER[prefix] || FIRST_ID) + 1;
    return prefix + ID_TRACKER[prefix];
};

export function skipIds(count, prefix = "id-") {
    ID_TRACKER[prefix] = ID_TRACKER[prefix] || FIRST_ID;
    ID_TRACKER[prefix] += count;
}

export function resetId(prefix = "id-") {
    ID_TRACKER[prefix] = FIRST_ID;
};

export function resetAllIds() {
    for (const key of Object.keys(ID_TRACKER)) {
        ID_TRACKER[key] = FIRST_ID;
    }
};